import { PropsWithChildren } from 'react'

import { useGetQuestionnaireArtifactPreviewUrl } from '@/api/old-assessor-questionnaire.hook'

import { useTrackCallback } from '@/lib/analytics/events'

import { Hyperlink } from '@/components/lemmala-design-system/link/hyperlink'

type QuestionnaireArtifactHyperlinkProps = {
  questionnaireArtifactId: string
  filename: string
} & PropsWithChildren

export const QuestionnaireArtifactHyperlink = ({
  questionnaireArtifactId,
  filename,
  children,
}: QuestionnaireArtifactHyperlinkProps) => {
  const trackQuestionnaireArtifactView = useTrackCallback('questionnaire.artifact.view')
  const { previewUrl } = useGetQuestionnaireArtifactPreviewUrl({
    questionnaireArtifactId,
    filename,
  })

  return (
    <Hyperlink
      onClick={() => trackQuestionnaireArtifactView({ artifactId: questionnaireArtifactId })}
      href={previewUrl}
    >
      {children}
    </Hyperlink>
  )
}
